import {inject, Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {APP_CONFIG} from "../../app-config";

@Pipe({
  name: 'changeDomain',
  standalone: true
})
export class ChangeDomainPipe implements PipeTransform {

    appConfig = inject(APP_CONFIG);

    constructor() {}

    transform(text: string) {
        return text.replaceAll('{{domain}}', this.appConfig.domain);
    }
}
